<!--
 * @Author: zhaoyang
 * @Date: 2020-10-28 10:28:03
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-05 11:13:36
 * @Description: 退款详情展示
-->
<template>
  <div class="detail-container">
    <div class="info-item info-title">{{$t('components_order_corder_refound_detail_608')}}</div>
    <div class="info-item">
      <span class="info-label">{{$t('components_order_c_order_round_597')}}</span
      ><span>{{ refoundSkillInfo.refundNum }}</span>
    </div>
    <div class="info-item">
      <span class="info-label">{{$t('components_order_c_order_round_599')}}</span
      ><span>{{$t('upgrade_page_views_order_components_pay_info_343', [ refoundSkillInfo.refundAmount ])}}</span>
    </div>
    <!-- <div
      v-if="
        refoundInfo &&
        refoundInfo.orderDto &&
        refoundInfo.orderDto.status == 'REFUND_SUCCESS'
      "
      class="info-item"
    >
      <span class="info-label">退款理由</span>
      <span class="desc-con"> {{ refoundREason }}</span>
    </div> -->
    <div class="info-item">
      <span class="info-label">{{$t('components_order_corder_refound_detail_609')}}</span>
      <span class="desc-con">
        {{ refoundInfo.cdesc ? refoundInfo.cdesc : refoundInfo.bdesc }}</span
      >
    </div>
    <div v-if="refoundInfo.images && refoundInfo.images.length" class="info-item img-con">
      <span class="info-label">{{$t('components_order_corder_refound_detail_610')}}</span>
      <upload-view
        :images="refoundInfo.images"
      ></upload-view>
    </div>
    <div class="info-item">
      <span class="info-label">{{$t('components_order_corder_refound_detail_611')}}</span
      ><span>{{ refoundInfo.createTime }}</span>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import uploadView from '@/components/common/upload/upload-view';
export default {
  created() {},
  props: {
    refoundInfo: {
      type: Object,
      default: () => {
        return {
          orderDto: {
            status: '',
          },
        };
      },
    },
  },
  computed: {
    refoundSkillInfo() {
      if (!this.refoundInfo.tradeRefundDetailList) return {};
      return this.refoundInfo.tradeRefundDetailList[0] || {};
    },
    refoundREason() {
      if (!this.refoundInfo.refundReason) return '';
      const map = {
        C_AGREE: i18n.t('components_order_corder_refound_detail_612'),
        UNABLE_MEET_DEMAND: i18n.t('components_order_corder_refound_detail_613'),
        USER_VIOLATIONS: i18n.t('components_order_corder_refound_detail_614'),
        OTHER: i18n.t('filters_index_89'),
      };
      const key = this.refoundInfo.refundReason;
      return map[key];
    },
  },
  components: {
    uploadView,
  },
};
</script>
<style lang="scss" scoped>
.detail-container {
  font-size: 14px;
  line-height: 15px;
  color: #222c43;
}
.info-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  min-height: 48px;
  line-height: 48px;
  padding: 0 18px;

  img {
    width: 56px;
    height: auto;
  }
}
.info-title {
  height: 53px;
  font-size: 16px;
  font-weight: 500;
  border-top: 1px solid #f1f4f6;
}
.info-label {
  color: #636d86;
}
.refound-reason {
  width: 100%;
  margin-top: 8px;
  line-height: 24px;
}
.desc-con {
  word-break: break-all;
  max-width: 200px;
  line-height: 19.1px;
}
.img-con {
  line-height: 20px;
  align-items: flex-start;
}
</style>
